import { format as fnsFormat, isSameDay, addDays, subDays, formatDistanceStrict } from "date-fns";
import * as deLocale from "date-fns/locale/de";
import { t } from "i18next";
import { store } from "../store/index";

export const formatDistanceStrictToNow = (date: string | number | Date) => {
	return formatDistanceStrict(date, new Date(), {
		locale: deLocale
	});
};

export const format = (date: string | number | Date, format: string) => {
	return fnsFormat(date, format, {
		locale: deLocale
	});
};

export const formatDate = (dateInput: string | number | Date) => {
	const date = new Date(dateInput);

	if (isSameDay(date, new Date())) {
		return t("datepicker.today");
	} else if (isSameDay(date, subDays(new Date(), 1))) {
		return t("datepicker.yesterday");
	} else if (isSameDay(date, addDays(new Date(), 1))) {
		return t("datepicker.tomorrow");
	}

	const formatString =
		store.getState().layout === "phone" ? "dd DD.MM.YY" : "dd DD. MMMM YY";

	return format(date, formatString);
};

export const setDateToMidnight = (date: Date) => {
	const newDate = new Date(date.getTime());
	newDate.setHours(0, 0, 0, 0);

	return newDate;
};

export const getUnixTimestamp = (
	date: Date,
	normalize = false,
	ceil = false
) => {
	let ts;

	if (normalize) {
		ts = setDateToMidnight(date).getTime();
	} else {
		ts = date.getTime();
	}

	if (ceil) {
		return Math.ceil(ts / 1000);
	}

	return Math.floor(ts / 1000);
};
